import { render, staticRenderFns } from "./ContentDisplay.vue?vue&type=template&id=35cdbcd0&scoped=true&"
import script from "./ContentDisplay.vue?vue&type=script&lang=js&"
export * from "./ContentDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ContentDisplay.vue?vue&type=style&index=0&id=35cdbcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdbcd0",
  null
  
)

/* custom blocks */
import block0 from "./ContentDisplay.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports